import React from "react";

const BenefitCard = ({ icon: Icon, title, copy }) => (
  <article className="benefit">
    <div className="benefit__icon" aria-hidden="true">
      <Icon fontSize="inherit" />
    </div>
    <h3 className="benefit__title">{title}</h3>
    <p className="benefit__copy">{copy}</p>
  </article>
);

export default BenefitCard;
